function resizeCTA(el) {
  const widthThreshold = 725;
  if (el.clientWidth < widthThreshold) {
    el.classList.add('dmc-cta-small');
  } else {
    el.classList.remove('dmc-cta-small');
  }
}

export function runCTATracking() {
  try {
    const elements = document.querySelectorAll('[data-cta-container]')
    let resizeObserver = null;
    if (!!window.ResizeObserver) {
      resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          resizeCTA(entry.target)
        })
      })
    }
    elements.forEach((element) => {
      resizeCTA(element)
      if (resizeObserver) {
        resizeObserver.observe(element)
      }
    })
    window.addEventListener('resize', () => {
      elements.forEach((element) => {
        resizeCTA(element)
      })
    })
  } catch (e) {
    console.error('Error in runCTATracking:', e);
  }
}